export const PINYWORLD_API_END_POINT =
  process.env.REACT_APP_PINYWORLD_API_END_POINT;
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
export const SHARE_URL = process.env.REACT_APP_SHARE_URL;
